module.exports = __webpack_public_path__ + "assets/img/banner-8.df9b715b.png";